import type { IFlyerCarouselResources } from "@/src/homepage/Flyers/FlyerCarousel.Resources";

export const FlyerCarouselResourcesEn: IFlyerCarouselResources = {
    newFlyerLabel: "New Flyer",
};
